import React from 'react'
import { Link } from 'react-router-dom'

export default function Navigation_ev_tiago() {
  return <>

<nav className="navbar navbar-expand-lg text-dark bg-light">
  <div className="container-fluid">
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse d-flex justify-content-center" id="navbarNavAltMarkup" style={{rowGap:'10px'}}>
      <div className="navbar-nav text-dark">
      <Link className="nav-link  text-dark" to="/ev/icng"><b>iCNG</b> </Link>
        <Link className="nav-link text-dark" to="/ev/tiago"><b>Tiago EV </b> </Link>
        {/* <Link className="nav-link text-light" to="/tiago_features">Features</Link> */}
      </div>
    </div>
  </div>
</nav>


  
  </>
}
